import React from 'react';
import { ChevronUp, LayoutGrid } from 'lucide-react';
import { useTheme } from '../styles/ThemeContext';
interface InteriorBottomBarProps {
  modelName: string;
  customizationPercent: number;
  onNavigationClick: () => void;
  onRoomsClick: () => void;
  isRoomsMenuOpen: boolean;
}
export function InteriorBottomBar({
  modelName,
  customizationPercent,
  onNavigationClick,
  onRoomsClick,
  isRoomsMenuOpen
}: InteriorBottomBarProps) {
  const {
    isDark
  } = useTheme();
  return <div className={`absolute bottom-0 left-0 right-0 z-20 backdrop-blur-xl transition-colors duration-300 ${isDark ? 'bg-slate-900/70 border-t border-white/10' : 'bg-white/70 border-t border-white/40'}`} data-id="element-255">
      <div className="flex items-center justify-between px-6 h-[50px]" data-id="element-256">
        {/* Left: Model Info */}
        <div className="flex items-center gap-6" data-id="element-257">
          <div className="flex flex-col" data-id="element-258">
            <span className={`font-bold text-sm tracking-wide ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-259">
              {modelName}
            </span>
          </div>
          <div className={`h-8 w-px ${isDark ? 'bg-white/10' : 'bg-gray-300/50'}`} data-id="element-260" />
          <div className="flex items-center gap-2" data-id="element-261">
            <span className={`font-bold text-sm ${isDark ? 'text-cyan-400' : 'text-teal-600'}`} data-id="element-262">
              {customizationPercent}%
            </span>
            <span className={`text-xs uppercase tracking-wider font-medium ${isDark ? 'text-white/40' : 'text-gray-500'}`} data-id="element-263">
              Customized
            </span>
          </div>
        </div>

        {/* Center: Hide Menu Hint */}
        <div className={`absolute left-1/2 -translate-x-1/2 flex items-center gap-3 text-[10px] font-medium uppercase tracking-widest ${isDark ? 'text-white/30' : 'text-gray-400'}`} data-id="element-264">
          <div className="flex gap-1" data-id="element-265">
            <div className={`w-3 h-4 border rounded-t-md rounded-b-md relative ${isDark ? 'border-white/30' : 'border-gray-400'}`} data-id="element-266">
              <div className={`absolute top-0.5 right-0.5 w-1 h-1.5 rounded-[1px] ${isDark ? 'bg-white/50' : 'bg-gray-500'}`} data-id="element-267" />
            </div>
          </div>
          <span data-id="element-268">Mouse Right Click to hide menu</span>
        </div>

        {/* Right: Navigation Buttons */}
        <div className="flex items-center h-full" data-id="element-269">
          <button onClick={onNavigationClick} className={`h-full flex items-center gap-2 px-6 transition-colors group ${isDark ? 'bg-white/5 hover:bg-white/10 text-white/70 hover:text-white border-l border-white/5' : 'bg-white/30 hover:bg-white/50 text-gray-600 hover:text-gray-900 border-l border-white/40'}`} data-id="element-270">
            <ChevronUp className="w-4 h-4 group-hover:-translate-y-0.5 transition-transform" data-id="element-271" />
            <span className="text-xs font-bold uppercase tracking-wider" data-id="element-272">
              Navigation
            </span>
          </button>
          <button onClick={onRoomsClick} className={`h-full flex items-center gap-2 px-6 transition-colors group ${isRoomsMenuOpen ? isDark ? 'bg-cyan-600 text-white' : 'bg-teal-600 text-white' : isDark ? 'bg-white/5 hover:bg-white/10 text-white/70 hover:text-white border-l border-white/5' : 'bg-white/30 hover:bg-white/50 text-gray-600 hover:text-gray-900 border-l border-white/40'}`} data-id="element-273">
            <LayoutGrid className="w-4 h-4" data-id="element-274" />
            <span className="text-xs font-bold uppercase tracking-wider" data-id="element-275">
              Rooms
            </span>
          </button>
        </div>
      </div>

      {/* Progress Bar */}
      <div className={`absolute top-0 left-0 h-[2px] w-full ${isDark ? 'bg-white/5' : 'bg-gray-200'}`} data-id="element-276">
        <div className={`h-full ${isDark ? 'bg-cyan-500 shadow-[0_0_10px_rgba(6,182,212,0.5)]' : 'bg-teal-600 shadow-[0_0_10px_rgba(13,148,136,0.3)]'}`} style={{
        width: `${customizationPercent}%`
      }} data-id="element-277" />
      </div>
    </div>;
}